import React, { useState, useEffect } from 'react';
import { CompleteAssessment } from '../capabilities/types';
import { getLatestCompleteAssessment } from '../capabilities/capabilityStorage.service';
import { SelfTestResults } from './testDefinitions';
import AssessmentSummary from './AssessmentSummary';

interface AssessmentSummaryLoaderProps {
  userId: string;
  goalId: string;
  selfTestResults: SelfTestResults | null;
  onClose: () => void;
}

/**
 * AssessmentSummaryLoader - Wrapper that loads assessment data before showing summary
 */
const AssessmentSummaryLoader: React.FC<AssessmentSummaryLoaderProps> = ({
  userId,
  goalId,
  selfTestResults,
  onClose,
}) => {
  const [completeAssessment, setCompleteAssessment] = useState<CompleteAssessment | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadAssessment = async () => {
      try {
        const assessment = await getLatestCompleteAssessment(userId, goalId);
        setCompleteAssessment(assessment);
      } catch (err) {
        console.error('Failed to load assessment:', err);
      } finally {
        setIsLoading(false);
      }
    };
    loadAssessment();
  }, [userId, goalId]);

  if (isLoading) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <div className="bg-white rounded-lg p-6">
          <div className="flex items-center gap-3">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            <p className="text-gray-700">Laden...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!completeAssessment) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <div className="bg-white rounded-lg p-6">
          <p className="text-gray-700 mb-4">Geen assessment gevonden</p>
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors"
          >
            Sluiten
          </button>
        </div>
      </div>
    );
  }

  return (
    <AssessmentSummary
      completeAssessment={completeAssessment}
      selfTestResults={selfTestResults}
      onClose={onClose}
    />
  );
};

export default AssessmentSummaryLoader;
